/**
 * The navigation rail's width, in one place.
 *
 * Three components need this number and they had all drifted apart during the
 * carve-out: the rail itself used 232/64, TopAppBar reserved a hardcoded 240
 * for the logo, and ToastOffsetSync assumed 240/72 with xxl/uhd variants the
 * rail does not implement. None of that fails loudly -- it is a few pixels of
 * misalignment nobody traces back to a constant -- so they live together here.
 *
 * The values match ReportGen's drawer (240/72) so the two apps' rails are the
 * same size, which is what makes switching between them not feel like a jump.
 */
export const NAV_RAIL_WIDTH_EXPANDED = 240;
export const NAV_RAIL_WIDTH_COLLAPSED = 72;

/** Rail width for a given expanded state. */
export function navRailWidth(expanded: boolean): number {
  return expanded ? NAV_RAIL_WIDTH_EXPANDED : NAV_RAIL_WIDTH_COLLAPSED;
}
